module.exports = new __parcel__URL__("report-burndown.972f8546.svg").toString();